export { default as signupFeature } from './signupFeature.js';
export { default as hotButtons } from './hotButtons.js';
import * as socialNetworkWidget from './socialNetworkWidget.js';

export function initSeoSocial() {
  $(globalThis).on('load', function () {
    socialNetworkWidget.facebookfeed(true);
  });
}
